<template>
	<div id="forgotpasscode" class="app flex-row text-center">
		<img class="logo" :src="league.Params.LeagueLogo"><br>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-12 mt-4">
					<div class="card-group">
						<div class="card" style="border: 1px solid #e7e7e7;box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);">
							<div class="card-body">
								<h1>Forgot <span v-html="(user.playercontact == 'p' ? 'Player' : (user.playercontact == 't' ? 'Team Contact' : 'Player/Team Contact'))"></span> ID</h1>
								<p v-if="user.playercontact" class="text-muted">Enter the Email Address used during Registration to retrieve your <span v-html="(user.playercontact == 'p' ? 'Player' : (user.playercontact == 't' ? 'Team Contact' : 'Player/Team Contact'))"></span> ID required to view Schedules</p>
								<p v-else class="text-muted">Select whether you are looking for your Player or Team Contact ID.</p>
								<el-form ref="forgotpasscodeForm" label-position="top" :model="user" :rules="rules" label-width="120px">
									<el-form-item label="Player ID or Team Contact ID" prop="playercontact"
										:rules="[
												{ required: true, message: 'ID Type is Required'},
										]"
									>
										<el-radio-group v-model="user.playercontact">
											<el-radio-button value="p">Player ID</el-radio-button>
											<el-radio-button value="t">Team Contact ID</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<template v-if="user.playercontact">
										<el-form-item
											prop="username"
											:rules="[
												{ required: true, message: 'Email is required'},
												{ type: 'email',  message: 'Email is invalid', trigger: 'blur'}

											]"
										>
											<el-input placeholder="Email" v-model="user.username" @keyup.enter="submitForm">
												<template #prepend><i class="fa-light fa-user"></i></template>
											</el-input>
										</el-form-item>
										<div class="sample-captcha">
											<el-form-item label="Please enter the CAPTCHA value below (case sensitive)" prop="captchavalue">
												<el-input v-model="user.captchavalue" class="vue_client_recaptcha_input">
												</el-input>
												<div style="width: 1000%;">
													<VueClientRecaptcha
														:value="user.captchavalue"
														chars="23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz"
														custom-text-color="black"
														@isValid="isCaptchaValid"
													/>
												</div>
											</el-form-item>
										</div>
									</template>
	                            </el-form>
							</div>
							<div class="row">
								<div class="col-12 mb-4">
									<el-button type="success" size="default" style="width: 150px;text-align: center;" v-on:click="submitForm">Submit</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import VueClientRecaptcha from "../../../node_modules/vue-client-recaptcha/dist/vue-client-recaptcha.es";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
	name: 'forgotpasscode',
	components: {
		VueClientRecaptcha,
	},
	data() {
		var validateCaptcha = (rule, value, callback) => {
			if (value) {
				if (this.captcharesult) {
					callback();
				} else {
					callback(new Error('Captcha must match above text (case sensitive)'));
				}
			} else {
				callback(new Error('Captcha is Required'));
			}
		};
		return {
			user: {
				username: ''
			},
			currentStatus: 0,
			showContactUsForm: false,
			league : {Params : {}},
			captcharesult : false,
			rules: {
				captchavalue: [
					{ validator: validateCaptcha, trigger: 'blur' }
				],
			}
		}
	},
	props:["config", "parentrefs"],
	computed: {
		SiteName() {
			return this.config.Params.SiteName
		}
	},
	methods: {
		isCaptchaValid (value) {
			this.captcharesult = value;
		},
	    submitForm: function(event) {
	        event.stopPropagation();
            this.$refs['forgotpasscodeForm'].validate((valid) => {
            	if (valid) {
					if (this.currentStatus == STATUS_SAVING) {
						return true;
					}
					this.currentStatus = STATUS_SAVING;
					axios.post('/login/ForgotPasscode', {
						username: this.user.username,
						playercontact: this.user.playercontact,
                        LeagueID : this.league.LeagueID
					}).then(response => {
						this.currentStatus = STATUS_INITIAL;
						if (response.data.result == 'success') {
							this.$notify({
								title: 'Success',
								message: "Your " + (this.user.playercontact == 'p' ? 'Player' : (this.user.playercontact == 't' ? 'Team Contact' : 'Player/Team Contact')) + " ID has been sent to the Email Address Provided.",
								type: 'success',
								duration: 2000,
								showClose: false
							});
							setTimeout(() => { window.close(); }, 2500);
		                } else {
							this.displayPopup (response.data.message);
		                }
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
					});
		        } else {
		            this.displayPopup ('All fields are required.');
		        }
		    });
	    },
		getLeague: function() {
			axios.post('/analyzer/leagues/get', {
				LeagueShortName : this.$route.params.League
			}).then(response => {
				if (response.data.result == 'success') {
					this.league = response.data.league
				}
			});
	    },
        displayPopup (message) {
			this.$alert(message, 'Forgot ' + (this.user.playercontact == 'p' ? 'Player' : (this.user.playercontact == 't' ? 'Team Contact' : 'Player/Team Contact')) + ' ID Error', {
				confirmButtonText: 'OK',
			});
        }
	},
	mounted() {
		this.getLeague();


	},
}
</script>
<style>
	#app.forgotpasscode {
		margin-top: 0px;
		height: 100vh;
		overflow: hidden;
	}
	#app.forgotpasscode .page-wrapper {
		margin-left: 0px;
		margin-top: 0px;
		padding-top: 30px;
		}

	#app.forgotpasscode .card {
		margin-top: 0px;
		padding-top: 20px;
	}
</style>
<style scoped>
	@media (min-width: 576px) {
		#app .container-sm, .container {
			max-width: 700px;
		}
	}
	#app {
		margin-top: 0px;
	}
	.logo {
		max-width: 50%;
		max-height: 150px;
	}
	.card-body p, .card-body h2 {
		color: #fff;
	}
	.align-items-center {
		text-align:center;
	}
	div.vue_client_recaptcha {
		display: flex;
		justify-content: left;
		flex-direction: row;
		border: 1px solid #999999;
		margin-top: 10px;
		width: 196px;
	}
	.vue_client_recaptcha_input {
		width: 196px;
	}
</style>
